import { NOT_ASSIGNED_OPTION } from '@/constants/customFieldFilterConstants';
import type { ClientsFilters, ClientsTableParams } from '../models/clientsListTypes';

export function buildClientsTableParams(f: ClientsFilters): ClientsTableParams {
  const params: ClientsTableParams = {
    limit: f.pageSize,
    // A row offset (ClientRepo pages with OFFSET n ROWS), unlike /matters/table's page index.
    offset: (f.page - 1) * f.pageSize,
    orderBy: f.orderBy,
    sortAscending: f.sortAscending,
    showOrphans: f.orphans,
  };

  if (f.search) params.search = f.search;

  // No account means the server scopes to the caller and returns every client they can see.
  if (f.scopeAccount) {
    params.scopeAccount = f.scopeAccount.id;
    // Without this, a scope with no role ticked reads server-side as "all clients" rather
    // than "clients involving this account in any capacity".
    params.involved = true;
    params.originating = f.originating;
    params.primary = f.primary;
    params.reviewer = f.reviewer;
  }

  if (f.checkQuickbooks) {
    params.checkQuickbooks = true;
    params.qbConnectionType = f.qbConnectionType;
  }

  Object.entries(f.clientCustomFields)
    .filter(([, optionId]) => optionId)
    .forEach(([fieldId, optionId], index) => {
      params[`clientCustomField[${index}].fieldId`] = fieldId;
      if (optionId !== NOT_ASSIGNED_OPTION) {
        params[`clientCustomField[${index}].optionId`] = optionId;
      }
    });

  return params;
}

/** "Last, First" with whichever half is missing dropped, so an empty contact is "". */
export const formatContactName = (contactName: string | null | undefined): string =>
  (contactName ?? '')
    .split(',')
    .map((part) => part.trim())
    .filter(Boolean)
    .join(', ');
